import { s as styleInject } from './style-inject.es-746bb8ed.js';

var css_248z = ".FYp6A{direction:ltr}.ttAOD{direction:rtl}.gwgq-{background:transparent;border:none;cursor:pointer;display:flex;outline:none;padding-inline-end:14px;padding-inline-start:10px}.gwgq-:hover{opacity:.7}.ttAOD .gwgq-{transform:scaleX(-1)}.upQuo{fill:#646464;color:#646464;outline:none;transition:transform .15s linear}.upQuo.zhsC7{transform:rotate(90deg)}.j4aeQ{overflow-wrap:break-word;width:100%;word-break:break-word}";
var collapsibleListStyles = {"ltr":"FYp6A","rtl":"ttAOD","iconContainer":"gwgq-","icon":"upQuo","isExpanded":"zhsC7","listDimensions":"j4aeQ"};
styleInject(css_248z);

export { collapsibleListStyles as c };
//# sourceMappingURL=collapsible-list-component.rtlignore-5bc1d12d.js.map
